import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Image from 'assets/illustrations/no-notifications.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'

const NoNotifications = () => {
  const t = useTranslation()
  const classes = useStyles()

  return (
    <Box px={2} display="flex" flexDirection="column" alignItems="flex-start">
      <Typography variant="body1" gutterBottom>
        {t('empty-notifications:title')}{' '}
        <span role="img" aria-label="dialog">
          💬
        </span>
      </Typography>
      <Box mb={2} maxWidth={440} textAlign="left">
        <Typography variant="subtitle1" color="textSecondary">
          {t('empty-notifications:subtitle')}
        </Typography>
      </Box>
      <img src={Image} alt="" className={classes.image} />
    </Box>
  )
}

export default NoNotifications
